import { render, staticRenderFns } from "./BasicPageTop.vue?vue&type=template&id=5a815cfd&"
import script from "./BasicPageTop.vue?vue&type=script&lang=js&"
export * from "./BasicPageTop.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageTop.vue?vue&type=style&index=0&id=5a815cfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports